/**
 * Todos los filtros y la ordenación que `InputRadioTagTable` escribe en su
 * cursor, a su valor «vacío».
 *
 * El reducer de `setCursor` MEZCLA con lo que ya había, así que un `{}` no
 * borra nada: hay que nombrar cada clave. La papelera de la tabla y el vaciado
 * al abrir un modal (`useFreshTableCursor`) usan esta misma lista. Si un filtro
 * nuevo se quedara fuera de una de las dos, sobreviviría entre aperturas y se
 * aplicaría a escondidas (2026-10-26: el modal «Vincular OT» hacía
 * `setCursor(id, {})` y reabría con el expediente de la vez anterior).
 */
export const CLEARED_TABLE_FILTERS = {
  indexType: undefined,
  indexExpedition: undefined,
  subCapitolId: undefined,
  capitolId: undefined,
  predefinedOrderId: undefined,
  concessionId: undefined,
  teamIds: undefined,
  fromDate: undefined,
  toDate: undefined,
  fromEndDate: undefined,
  toEndDate: undefined,
  classification: undefined,
  track: undefined,
  orderBy: 'desc',
  sortField: undefined, // orden por defecto (registerInitDate desc)
  state: undefined,
  states: undefined,
  userIds: undefined,
  operatorIds: undefined,
  includeInactive: undefined,
  pkInitKm: undefined,
  pkInitMeter: undefined,
  pkEndKm: undefined,
  pkEndMeter: undefined,
  description: undefined,
  routeName: undefined,
  roadId: undefined,
  // «Solo importantes» (banderitas): sin esto la papelera no lo quitaría.
  onlyFlagged: undefined,
} as const;
